<template>
  <div>
    <div class="head-box">
      <h4>新手向导</h4>
      <div class="c-flex"></div>
    </div>
    <div class="content-box">
      <div
        class="c-flex flex-d-column c-w-1"
        style="padding:40px;align-items: center;justify-content: space-around;"
      >
        <!-- <p>新手向导</p> -->
        <div style="white-space: nowrap;overflow-x: auto;" class="c-flex">
          <template v-for="(item, index) of list">
            <div class="wizard-li" :key="index">
              <div
                :style="`--bBgColor:${item.isAction ? item.bBgColor : '#fff'}`"
                class="wizard-block-wrapper"
                @click="actionClick(index)"
              >
                <img class="c-w-1 c-h-1" :src="item.isAction ? item.imgUrlb : item.imgUrl" alt="" />
              </div>
              <span style="color:gray">{{ item.name }}</span>
              <img
                v-if="index != 3"
                class="wizard-arrow-right"
                src="https://pub.fsgo365.cn/1127697865013415676.png"
                alt=""
              />
            </div>
          </template>
        </div>
        <template v-for="(item, index) of list">
          <div class="wizard-memo-wrapper" :key="index" v-if="item.isAction">
            <div class="wizard-memo">
              <p style="font-weight: 500;margin:10px 0;font-size: 16px;">{{ item.name }}</p>
              <template v-if="index == 0">
                <p style="margin-bottom:10px">
                  组织架构非常牛，组织架构模块非常牛，组织架构模块非常牛，组织架构模块非常牛，组织架构模块非常牛，组织架构模块非常牛，组织架构模块非常牛，组织架构模块非常牛。
                  <el-link type="primary" @click="$router.push({ path: '/ServiceAppointments' })">
                    前往组织架构设置
                  </el-link>
                </p>
              </template>
              <template v-if="index == 1">
                <p style="margin-bottom:10px">
                  工单模块非常牛，工单模块非常牛，工单模块非常牛，工单模块非常牛，工单模块非常牛，工单模块非常牛，工单模块非常牛，工单模块非常牛，工单模块非常牛。
                  <el-link
                    type="primary"
                    @click="
                      $router.push({ path: '/ServiceAppointments' });
                      displayWizard({ colName: 'ServiceAppointments', show: true });
                    "
                  >
                    前往工单设置
                  </el-link>
                </p>
                <p style="margin-bottom:10px">
                  流程配置非常牛，流程配置非常牛，流程配置非常牛，流程配置非常牛，流程配置非常牛，流程配置非常牛，流程配置非常牛，流程配置非常牛，流程配置非常牛。
                  <el-link type="primary" @click="$router.push({ path: '/ServiceAppointments' })">
                    前往流程配置
                  </el-link>
                </p>
              </template>
              <template v-if="index == 2">
                <p style="margin-bottom:10px">
                  客户配置，非常牛。客户配置，非常牛。客户配置，非常牛。客户配置，非常牛。客户配置，非常牛。客户配置，非常牛。
                  <el-link type="primary" @click="$router.push({ path: '/ServiceAppointments' })">
                    前往配置设置
                  </el-link>
                </p>
              </template>
              <template v-if="index == 3">
                <p style="margin-bottom:10px">
                  周期计划，非常牛。周期计划，非常牛。周期计划，非常牛。周期计划，非常牛。周期计划，非常牛。周期计划，非常牛。
                  <el-link type="primary" @click="$router.push({ path: '/ServiceAppointments' })">
                    前往周期计划设置
                  </el-link>
                </p>
                <p style="margin-bottom:10px">
                  备件管理，非常牛。备件管理，非常牛。备件管理，非常牛。备件管理，非常牛。备件管理，非常牛。备件管理，非常牛。
                  <el-link type="primary" @click="$router.push({ path: '/ServiceAppointments' })">
                    前往备件管理设置
                  </el-link>
                </p>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'NoviceWizard',
  inject: ['displayWizard'],
  data() {
    return {
      options: {},
      list: [
        {
          imgUrl: 'https://pub.fsgo365.cn/6030503753677911471.png', //未选中的图片
          imgUrlb: 'https://pub.fsgo365.cn/3092047429507265514.png', //选中的图片
          name: '组织架构',
          bBgColor: '#409eff', //边框、背景颜色
          isAction: true //是否被选中
        },
        {
          imgUrl: 'https://pub.fsgo365.cn/3865532475543961274.png',
          imgUrlb: 'https://pub.fsgo365.cn/166261790184917220.png',
          name: '配置工单',
          bBgColor: '#f3ca7e',
          isAction: false
        },
        {
          imgUrl: 'https://pub.fsgo365.cn/8206018466003503443.png',
          imgUrlb: 'https://pub.fsgo365.cn/8198828552554527836.png',
          name: '客户管理',
          bBgColor: '#87c38f',
          isAction: false
        },
        {
          imgUrl: 'https://pub.fsgo365.cn/4862609808781655522.png',
          imgUrlb: 'https://pub.fsgo365.cn/5069872623370222070.png',
          name: '其他配置',
          bBgColor: '#bd8cbb',
          isAction: false
        }
      ]
    };
  },
  mounted() {
    window.$this = this;
  },
  methods: {
    actionClick(index) {
      this.list.forEach((item, i) => (item.isAction = index == i));
    }
  }
};
</script>
<style lang="scss">
// .wizard-cir-wrapper {
//   border-radius: 50%;
//   padding: 10px;
//   border: 2px solid #409eff;
//   border: 2px solid var(--bBgColor, #409eff);
//   width: 100%;
//   height: 100%;
//   box-sizing: border-box;
//   margin-bottom: 10px;
// }
.wizard-block-wrapper {
  border-radius: 10%;
  padding: 10px;
  border: 2px solid #409eff;
  background-color: #409eff;
  border: 2px solid var(--bBgColor, #409eff);
  background-color: var(--bBgColor, #409eff);
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.wizard-li {
  width: 100px;
  height: 100px;
  padding: 50px 40px;
  display: inline-block;
  position: relative;
  text-align: center;
}
.wizard-arrow-right {
  position: absolute;
  right: -15px;
  transform: translate(0, -50%);
  top: 50%;
  width: 12px;
}
.wizard-memo {
  background: #fff;
  min-width: 150px;
  border: 1px solid #ebeef5;
  padding: 12px;
  z-index: 2000;
  color: #606266;
  line-height: 1.4;
  text-align: justify;
  font-size: 14px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  word-break: break-all;
}
.wizard-memo-wrapper {
  width: 80%;
  height: 140px;
}
</style>
